import { axiosV3 } from '@/helpers/_core/axios';
import { RESPONSE_TYPES } from '~/constants/_core/safea-v3';
import { getCallbackUrl } from '~/helpers/_core/safea-v3';

export default class OAuthV3 {
  static SERVICE_NAME = 'oauthV3';

  constructor({ app, wcStore, wcServices }) {
    this.axios = axiosV3(app, { wcServices, wcStore });
  }

  async getUserInfo() {
    return this.axios
      .withToken().get('/oauth2/userinfo')
      .then(r => r.data)
      .catch(err => {
        if (err.response && err.response.status === 401) {
          return null;
        }
        throw err;
      });
  }

  async refreshToken({ refreshToken }) {
    return this.axios.default().post('/oauth2/token', {
      grant_type    : RESPONSE_TYPES.REFRESH_TOKEN,
      redirect_uri  : getCallbackUrl(),
      refresh_token : refreshToken
    }).then(r => r.data);
  }

  async token(body) {
    return this.axios.default().post('/oauth2/token', {
      ...body,
      grant_type: 'authorization_code'
    }).then(r => r.data);
  }
}
